import { cn } from "@/domains/library"

type SortDirection = "desc" | "asc"

export const SortIcon = ({ direction, className }: { direction?: SortDirection; className?: string }) => {
  return (
    <svg
      className={cn(
        "h-4 w-4 fill-t300 transition-transform duration-300 ease-in-out",
        direction === "asc" ? "rotate-180" : "",
        className,
      )}
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" />
    </svg>
  )
}
